import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCol, MDBRow } from "mdbreact";

import Slider from "./Slider";
import HomeCardDeck from "./HomeCardDeck";
import colors from "../../colors";
import ShowMoreText from "react-show-more-text";
import pagecontent from "../Helpers/TrainingContent";
import AboutModal from "../../TrainingPortalModal";
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: true,
    };
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal,
    });
  };

  render() {
    return (
      <div
      className=" cardeck_full"
      
    >
      <div
      className="carddeck_inner"
        style={{
          // paddingTop: "0px",
          // paddingRight: "10px",
          // paddingBottom: "10px",
          // paddingLeft: "10px",
          backgroundColor: colors.background,
        }}
      >
       
          <AboutModal
            modal={this.state.modal}
            toggle={this.toggle}
            title={pagecontent.title}
            bodycontent={pagecontent.bodycontent}
          />
          <Slider />
          <HomeCardDeck />
          <div style={{ padding: "10px" }}>
            <MDBRow>
              <MDBCol>
                <MDBCard>
                  <MDBCardTitle style={{ padding: "10px", color: "blue" }}>
                    Capacity Building
                  </MDBCardTitle>
                  <MDBCardBody>
                    {/* <MDBCardText> */}
                    <ShowMoreText
                      lines={3}
                      more="Show more"
                      less="Show less"
                      anchorClass=""
                      onClick={this.executeOnClick}
                      expanded={false}
                    >
                      <p style={{ textAlign: "justify" }}>
                        Under NHP, NRSC is supporting through capacity building
                        of stakeholders and enabling effective utilization of
                        space technology products for water resources
                        management. The training programmes consist of Remote
                        Sensing &amp; GIS fundamentals and customized water
                        resources applications. <br />
                        The objectives of the capacity building programme are
                        <ol type="1">
                          <li>
                            {" "}
                            To conduct two training programs (one week) per year
                            on RS &amp; GIS fundamentals and state of art with
                            25 participants per batch (2017-18 to 2023-24)
                          </li>
                          <li>
                            To conduct two customized training programs (two
                            weeks) per year on RS &amp; GIS applications in
                            water resources with 25 participants per batch
                            (2017-18 to 2023-24)
                          </li>
                        </ol>
                      </p>
                    </ShowMoreText>

                    {/* </MDBCardText> */}
                  </MDBCardBody>
                </MDBCard>
              </MDBCol>
            </MDBRow>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
